import VagaroWidget from '../components/VagaroWidget';
import './Book.css';

export default function Book() {
  return (
    <main className="book-main">
      <h1 className="book-title">Book an appointment</h1>
      <p className="book-intro">Choose a service and time below to schedule your visit.</p>
      <VagaroWidget />
    </main>
  );
}
